import React, { useState } from "react"
import { Contact } from "../pages/Contact"
import { Portfolio } from "../pages/Portfolio"
import { Services } from "../pages/Services"
import { Hero } from "./Hero"

export const Home = () => {
  const[language, setLanguage]= useState(false)

  return (
    <>
      <Hero language={language} setLanguage={setLanguage} />
      <Services  language={language} setLanguage={setLanguage} />
      <Portfolio  language={language} setLanguage={setLanguage}  />
      <Contact language={language} setLanguage={setLanguage}/>
    </>
  )
}
